<script>
  export let name;
  $: type = name.slice(name.lastIndexOf('.') + 1);
</script>

{#if name.includes('.')}
  <span class="icon" style="background-image: url(icons/{type}.svg)">{name}</span>
{:else}
  <span>{name}</span>
{/if}

<style lang="scss" src="./file.scss"></style>
